import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaNewspaper, FaCalendarAlt, FaImages, FaUsers, FaUserPlus, FaTable, FaMoneyBillWave, FaDownload, FaQuestionCircle, FaComments, FaCog, FaSignOutAlt, FaBars, FaTimes, FaKey } from 'react-icons/fa';

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState('Administrator');

  const menuItems = [
    { icon: FaHome, label: 'Dashboard', path: '/admin' },
    { icon: FaNewspaper, label: 'News', path: '/admin/news' },
    { icon: FaCalendarAlt, label: 'Events', path: '/admin/events' },
    { icon: FaImages, label: 'Gallery', path: '/admin/gallery' },
    { icon: FaUsers, label: 'Staff', path: '/admin/staff' },
    { icon: FaUserPlus, label: 'Admissions', path: '/admin/admissions' },
    { icon: FaTable, label: 'Timetable', path: '/admin/timetable' },
    { icon: FaMoneyBillWave, label: 'Fees', path: '/admin/fees' },
    { icon: FaDownload, label: 'Downloads', path: '/admin/downloads' },
    { icon: FaQuestionCircle, label: 'FAQ', path: '/admin/faq' },
    { icon: FaComments, label: 'Testimonials', path: '/admin/testimonials' },
    { icon: FaKey, label: 'Change Password', path: '/admin/change-password' },
    { icon: FaCog, label: 'Settings', path: '/admin/settings' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <motion.aside 
        initial={{ x: -300 }}
        animate={{ x: 0 }}
        className={`bg-blue-900 text-white fixed h-full transition-all duration-300 z-50 ${
          isSidebarOpen ? 'w-64' : 'w-0 overflow-hidden'
        }`}
      >
        <div className="p-6 h-full flex flex-col">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-xl font-bold">Admin Panel</h2>
            <button onClick={() => setIsSidebarOpen(false)} className="lg:hidden">
              <FaTimes size={20} />
            </button>
          </div>
          
          <nav className="space-y-2 flex-1 overflow-y-auto">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="flex items-center space-x-3 px-4 py-3 rounded-lg hover:bg-blue-800 transition-all"
              >
                <item.icon className="text-lg" />
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>

          <div className="mt-4">
            <button
              onClick={handleLogout}
              className="flex items-center space-x-3 px-4 py-3 w-full rounded-lg bg-red-600 hover:bg-red-700 transition-all"
            >
              <FaSignOutAlt />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </motion.aside>

      {/* Main Content */}
      <div className={`flex-1 transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-0'} flex flex-col h-screen`}>
        {/* Top Bar */}
        <header className="bg-white shadow-md sticky top-0 z-40 flex-shrink-0">
          <div className="flex items-center justify-between px-6 py-4">
            <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="text-gray-600">
              <FaBars size={20} />
            </button>
            
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="font-semibold text-gray-800">{adminName}</p>
                <p className="text-sm text-gray-500">Administrator</p>
              </div>
              <div className="w-10 h-10 bg-blue-900 rounded-full flex items-center justify-center text-white font-bold">
                {adminName.charAt(0)}
              </div>
            </div>
          </div>
        </header>

        {/* Page Content - Scrollable */}
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
